/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button } from '@coursera/cds-core';

import {
  hasDegreeHomeV2OptOutCookie,
  removeDegreeHomeV2OptOutCookie,
  setDegreeHomeV2OptOutCookie,
} from 'bundles/degree-home/utils/experimentUtils';
import TrackedButton from 'bundles/page/components/TrackedButton';

import _t from 'i18n!nls/degree-home';

const DegreeHomeV2ExperienceButton: React.FunctionComponent<{}> = () => {
  const handleButtonClick = () => {
    if (hasDegreeHomeV2OptOutCookie()) {
      removeDegreeHomeV2OptOutCookie();
    } else {
      setDegreeHomeV2OptOutCookie();
    }
    window.location.reload();
  };

  return (
    <Button
      component={TrackedButton}
      className={hasDegreeHomeV2OptOutCookie() ? 'v1-to-v2-button' : 'v2-to-v1-button'}
      trackingName="change_experience_button"
      data={{ isClickingToOptOut: !hasDegreeHomeV2OptOutCookie() }}
      withVisibilityTracking={false}
      requireFullyVisible={false}
      size="small"
      variant="secondary"
      onClick={() => handleButtonClick()}
      css={css`
        margin-left: auto;
        max-width: 767px;
      `}
    >
      {hasDegreeHomeV2OptOutCookie() ? _t('Try new experience') : _t('Return to classic experience')}
    </Button>
  );
};

export default DegreeHomeV2ExperienceButton;
